import React, { useMemo, useCallback } from 'react';
import { IItemForGetShortInfoWithStatus } from 'types';
import { MultipleSelect } from './MultipleSelect';
import SelectedItem from 'components/SelectedItem/SelectedItem';
import style from './RestaurantsMultipleSelect.module.scss';

interface IProps {
	setSelectedRestaurantsTo: (value: string[]) => void;
	restaurants: IItemForGetShortInfoWithStatus[];
	IDSelectedRestaurantFrom: Nullable<string>;
	selectedRestaurantsTo: string[];
}

export const RestaurantsMultipleSelect: React.FC<IProps> = React.memo(
	({ setSelectedRestaurantsTo, restaurants, IDSelectedRestaurantFrom, selectedRestaurantsTo }) => {
		const handleRemove = useCallback(
			(id: string) => {
				const updatedSelectedItems = selectedRestaurantsTo.filter((el) => el !== id);
				setSelectedRestaurantsTo(updatedSelectedItems);
			},
			[selectedRestaurantsTo, setSelectedRestaurantsTo],
		);

		const availableRestaurants = useMemo(() => {
			return restaurants.filter((restaurant) => restaurant.id !== IDSelectedRestaurantFrom);
		}, [restaurants, IDSelectedRestaurantFrom]);

		const restaurantsList = useMemo(() => {
			return selectedRestaurantsTo.map((el) => {
				const label = availableRestaurants?.find((item) => item.id === el)?.name || '';

				return <SelectedItem key={el} label={label} onDelete={() => handleRemove(el)} />;
			});
		}, [selectedRestaurantsTo, availableRestaurants, handleRemove]);

		return (
			<div className={style.container} data-test="RestaurantsMultipleSelect">
				<MultipleSelect
					restaurants={availableRestaurants}
					setIDsRestaurant={setSelectedRestaurantsTo}
					IDsSelectedRestaurant={selectedRestaurantsTo}
				/>
				<div className={style.groupsList}>{restaurantsList}</div>
			</div>
		);
	},
);
